import RegiterMethodSelector from "./RegiterMethodSelector";
export default RegiterMethodSelector;
